import {Component} from '@angular/core';

@Component({
  selector: 'app-modal-payment-success',
  templateUrl: './modal-payment-success.component.html',
  styleUrls: ['./modal-payment-success.component.scss']
})
export class ModalPaymentSuccessComponent {
  public isModalPaymentSuccessShow: boolean = false;
  public isDarkBackground: boolean = false;

  modalSuccessShow() {
    this.isModalPaymentSuccessShow = true;
    this.isDarkBackground = true;
  }

  closeModal() {
    this.isModalPaymentSuccessShow = false;
    this.isDarkBackground = false;
  }
}
